const boxWrapperStyles: React.CSSProperties = {
    position: "absolute",
    padding: "16px",
    boxSizing: "border-box",
}

export { boxWrapperStyles }
